module.exports = function (name, classes, styles) {
    if (typeof classes == 'object') {
        classes = '';
    }
    if (typeof styles == 'object') {
        styles = '';
    }

    return '<img src="' + window.cdnBaseUrl + name + '" class="' + classes + '" styles="' + styles  +'">';
}
